/**
 * Created by Thomas Mark
 * Date: 2019-10-29
 * 
 * Fusszeile
 *
 */

import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { FooterItem } from "./FooterItem";
import * as utils from "../../basics/utils"
import * as appActions from "../../store/actions/appActions";
import * as portfolioActions from "../../store/actions/portfolioActions";

class Footer extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    render() {
        const { toolbarHeight, toolbarType, gridEdit, gridEditType, appPreview, unitHeight, currentContainer, path, online, appModus } = this.props.app;
        const { loginUser } = this.props.user;

        const dialog = utils.getDialogByPath(path);

        // Hintergrundfarbe festlegen
        let bgColor = ['search', 'favored', 'more'].includes(toolbarType) ? 'bg-white' : 'bg-black';
        if (toolbarType === 'portfolios') {
            if (dialog.dialogType === 'groups') bgColor = 'bg-white';;
            if (dialog.dialogType === 'products') bgColor = 'bg-white';;
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        const onClick = (type) => {
            if (gridEdit) {
                this.props.setGridEdit(false);
                return
            }

            if (type === 'sites') {
                this.props.setModalDialog('WebsiteModal', '');
                return;
            }
            if (type === 'preview') {
                this.props.setModalDialog('DownloadConfirmModal', null, { container: currentContainer, version: 'draft' }); // appAction.js
                return;
            }

            this.props.setToolbarType(type);

            this.props.closeModalDialog(); // appAction.js

            if (type === 'portfolios') this.props.setPath("");
        }

        const renderWorkInProgress = () => {
            const workInProgress = {
                backgroundImage: 'linear-gradient(45deg, #f1b20f 23.68%, #333333 23.68%, #333333 50%, #f1b20f 50%, #f1b20f 73.68%, #333333 73.68%, #333333 100%)',
                backgroundSize: '200px 200px'
            }

            const style = { ...utils.getStyleHeight(unitHeight * 0.4, .4, .4, .4), ...workInProgress };

            return <div className="w-full text-center absolute bottom-0" style={style}></div>
        }

        const renderAdmin = () => {
            let adminPath = "/";

            if (loginUser && loginUser.role === 'Admin') {
                adminPath = "/admin/users2"
            }

            return (
                <div className={`Admin flex w-full ${bgColor}`} style={utils.getStyleHeight(toolbarHeight, 1, 1, 1)}>
                    <FooterItem index={0} link={'/containers'} type={'containers'} label={'Kataloge'} callback={onClick} />
                    <div className="flex-grow"></div>
                    {online && <FooterItem index={1} link={adminPath} type={'Admin'} label={'Admin'} callback={onClick} />}
                </div>
            )
        }

        const renderExitGridEdit = () => {

            const gridEditTypeLabel = gridEditType ? 'Verschieben beenden' : 'Verschieben';
            const gridEditTypeIcon = gridEditType ? 'close' : 'gridMove';

            return (
                <div className={`ExitGridEdit flex w-full  ${bgColor}`} style={utils.getStyleHeight(toolbarHeight, 1, 1, 1)}>
                    {appModus === 'Admin' && <FooterItem index={0} link={null} type={'gridAdd'} label={'Neue Kachel'} callback={() => this.props.setModalDialog('PortfolioModal', 'create')} />}
                    {appModus !== 'Admin' && <FooterItem index={0} link={null} type={null} label={''} callback={null} />}
                    <FooterItem index={1} link={null} type={gridEditTypeIcon} label={gridEditTypeLabel} callback={() => this.props.setGridEditType(!gridEditType)} />
                    <FooterItem index={2} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={3} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={4} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={5} link={null} type={'gridClose'} label={'Beenden'} callback={() => this.props.setGridEdit(!gridEdit)} />
                </div>
            )
        }

        const renderEditCatalog = () => {
            return (

                <div className={`EditCatalog relative flex w-full ${bgColor}`} style={utils.getStyleHeight(toolbarHeight, 1, 1, 1)}>
                    {renderWorkInProgress()}
                    <div className="flex w-full">
                        <FooterItem index={0} link={'/containers'} type={'containers'} label={'Kataloge'} callback={onClick} />
                        <FooterItem index={1} link={'/portfolios'} type={'portfolios'} label={'Portfolios'} callback={onClick} />
                        <FooterItem index={2} link={null} type={'preview'} label={'Vorschau'} callback={onClick} />
                        <FooterItem index={3} link={'/icons'} type={'icons'} label={'Icons'} callback={onClick} />
                        <FooterItem index={4} link={null} type={'sites'} label={'Websites'} callback={onClick} />
                        <FooterItem index={5} link={'/more'} type={'more'} label={'Mehr'} callback={onClick} />
                    </div>
                </div>
            )
        }

        const renderVersions = () => {
            return (
                <div className={`Versions flex w-full ${bgColor}`} style={utils.getStyleHeight(toolbarHeight, 1, 1, 1)}>
                    <FooterItem index={0} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={1} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={2} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={3} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={4} link={null} type={null} label={''} callback={null} />
                    <FooterItem index={5} link={'/containers'} type={'close'} label={'Close'} callback={onClick} />
                </div>
            )
        }

        const renderStandard = () => {
            return (
                <div className={`Standard flex w-full ${bgColor}`} style={utils.getStyleHeight(toolbarHeight, 1, 1, 1)}>
                    <FooterItem index={0} link={'/containers'} type={'containers'} label={'Kataloge'} callback={onClick} />
                    <FooterItem index={1} link={'/portfolios'} type={'portfolios'} label={'Portfolios'} callback={onClick} />
                    <FooterItem index={2} link={'/portfolios'} type={'search'} label={'Suchen'} callback={onClick} />
                    <FooterItem index={3} link={'/portfolios'} type={'favored'} label={'Favoriten'} callback={onClick} />
                    <FooterItem index={4} link={null} type={'sites'} label={'Websites'} callback={onClick} />
                    <FooterItem index={5} link={'/more'} type={'more'} label={'Mehr'} callback={onClick} />
                </div>
            )
        }

        const renderNoToolbar = () => {
            return (
                <div className={`flex w-full ${bgColor}`} style={utils.getStyleHeight(toolbarHeight, 1, 1, 1)}>
                </div>
            )
        }


        if (gridEdit) return renderExitGridEdit();

        if (toolbarType === 'versions') return renderVersions();

        if (toolbarType === 'containers' || toolbarType === 'Admin') {
            if (loginUser && ["Admin", "Superadmin"].includes(loginUser._role)) {
                return renderAdmin();
            }
            return renderNoToolbar();
        }
        if (!appPreview) {
            return renderEditCatalog();
        }

        return renderStandard();
    }
}

function mapStateToProps(state) {
    return {
        app: state.app,
        user: state.user,
        portfolio: state.portfolio
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions, portfolioActions), dispatch);
}

const FooterWithState = connect(mapStateToProps, mapDispatchToProps)(Footer);
export default React.forwardRef((props, ref) => (
    <FooterWithState innerRef={ref} {...props} />
));
